<script>
export default {
    props: {
        data: {
            type: Object
        }
    },
    computed: {
        totalProducts(){
            //Check category for 'count attribute of calculated products in back end or tally subcategory product å'count'
            if (!!this.data.count) return this.data.count;
            if (!!this.data.subcategories) return this.data.subcategories.reduce((total, subcategory) => total + subcategory.count, 0);
        }
    },
};
</script>
